<style lang="scss">
@import "./component.scss";
</style>

<template>
  <div class="phone-field">
    <div class="country-code">
      <slot name="countryCode"></slot>
    </div>
    <div class="phone-number">
      <slot name="number"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhoneField",
  props: {}
};
</script>
